
/**
 * 플랫폼 지원
 */
export type CourseDraftSectionsItemLecturesItemPlatformSupport = typeof CourseDraftSectionsItemLecturesItemPlatformSupport[keyof typeof CourseDraftSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftSectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
